import {MI} from "../init";
import ServerResult from "../ServerResult";
import ResultController from "./ResultController";
import ReelsSpinner from "../reel/ReelsSpinner";

import events from "../../framework/src/events/EventsObservable";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import {madnes_add_win, madnes_reels_stop} from "../../framework/src/engine/madnes/madnes";
import {states} from "../../framework/src/engine/madnes/madnes_variables";
import {STATES} from "../../framework/src/states/states";
import {REELS_EVENTS} from "../../framework/src/game/slot/reelsEvents";

/**
 * @constructor
 */
export default function Game() {

    this.lastRoundEnded = true;

    this.spinEnabled = true;

    /** @type {GameMemory} */
    this.memory;

    /** @type {GameBonus} */
    this.bonus;

    /** @type {GameWild} */
    this.wild;

    /** @type {GameGroups} */
    this.groups;

    /** @type {GameConfig} */
    this.gameCfg;

    /** @type {SpinReels} */
    this.spinReels;

    /** @type {ReelsSpinner} */
    this._reelsSpinner;

    /** @type {ServerConfig} */
    this._serverConfig;

    /** @type {ResultController} */
    this._resultController;

    /** @type {SymbolsManager} */
    this.symbolsManager;

    /** @type {GameAssets} */
    this.assets;

    /** @type {Object<string,MadnesAudio>} */
    this.sounds;

    /** @type {ServerResult} */
    this._serverResult = new ServerResult();

    /** @type {ServerResult|null|undefined} */
    this._fsServerResult = null;

    this.gameRoundWin = 0;
    this.gameTotalCredit = 0;

    this._resultRequestLock = false;

    /**
     * @type {Promise|null}
     */
    this.waitForWinAdd = null;

    this._removeBetEnabled = true;

    this.inFreeSpins = false;

    this.freeSpinData = {
        'roundWin': 0,
        'count': 0,
        'pos': 0
    };

    /** @type {Object<string,MadnesAudio>} */
    this.sounds = {};

    /** @type {boolean} */
    this._forceAutostartEnabled = false;

    this._forceStopSoundPlayed = false;
    this._forceScatterSoundPlayed = false;

    this._wildPromises = [];
};

/** @const */
Game.prototype.NORMAL_WIN = 0;
/** @const */
Game.prototype.BIG_WIN = 1;
/** @const */
Game.prototype.MEGA_WIN = 2,
/** @const */
Game.prototype.SUPER_MEGA_WIN = 3;
/** @const */
Game.prototype.BONUS_WIN = 4;
/** @const */
Game.prototype.FS_WIN = 5;

//Game.prototype.reinitFreespinData = function() {
//	this.freeSpinData = {
//		'roundWin': 0,
//		'count': 0,
//		'pos': 0
//	};
//};

/**
 * @param {SpinReels} spinReels
 * @param {GameConfig} gameConfig
 * @param {ServerConfig} serverConfig
 * @param {SymbolsManager} symbolsManager
 * @param {GameAssets} gameAssets
 * @param {GameGroups} gameGroups
 * @returns {undefined}
 */
Game.prototype.init = function(spinReels, gameConfig, serverConfig, symbolsManager, gameAssets, gameGroups) {

    this.groups = gameGroups;

    this.spinReels = spinReels;
    this.gameCfg = gameConfig;
    this._serverConfig = serverConfig;
    this.symbolsManager = symbolsManager;
    this.assets = gameAssets;

    this._resultController = new ResultController(this, symbolsManager);
    //this._resultController.init();

    this._reelsSpinner = new ReelsSpinner(this.spinReels);

    this._reelsSpinner.setOnStart(this._onReelsStart.bind(this));
    this._reelsSpinner.setOnBrakeDown(this._onReelBrakeDown.bind(this));
    this._reelsSpinner.setOnBrakeUp(this._onReelBrakeUp.bind(this));
    this._reelsSpinner.setOnStop(this._onReelStop.bind(this));
    this._reelsSpinner.setOnComplete(this._onReelsComplete.bind(this));

    events.subscribe(GAME_EVENTS.GAME_ADD_RESULT, this._requestResult.bind(this));
    events.subscribe(GAME_EVENTS.GAME_END_ROUND_RECALCED, this._endRoundRecalced.bind(this));

};

Game.prototype.canRemoveBet = function() {

    if(this.inFreeSpins || !this._removeBetEnabled || MI.isLastRoundAutostart()) {
        return false;
    }

    return true;
};

/**
 * @param {boolean} bool FALSE to disable remove bet
 * @returns {undefined}
 */
Game.prototype.enableRemoveBet = function(bool) {
    this._removeBetEnabled = bool;
};

/**
 * @returns {boolean}
 */
Game.prototype.isInAutostart = function() {
    return MI.isAutoStartSet();
};

Game.prototype.endAutostart = function() {
    MI.endAutoStart();
};

Game.prototype._spinEnabled = function() {
    return this.spinEnabled && !MI.server.roundRunning();
};

Game.prototype.spinStart = function() {
    var _self = this;

    this._wildPromises = [];
    this.wild.stopAnimLock();

    this._reelSoundIndex = 1;

    this._forceAutostartEnabled = false;

    this._resultRequestLock = false;

    MI.controls.unsetForceStop();

    // if(!this._spinEnabled()) {
    // 	return;
    // }
    this.spinEnabled = false;

    // this._decreaseAutoStartCount();

    // var data = {money: money};

    // this._removeBet();

    if(this.bonus.inBonus()) {

        var wildMem = this.memory.getWildMemory();

        var bsNumber = wildMem["featureNumber"];
        var bsCount = wildMem["featureCount"];

//		console.log(bsNumber, bsCount);

        this.assets.header.setBoomSpinsCount(bsNumber - bsCount - 1);
    }

    this.sounds["reel_spin"].loop();

    this._reelsSpinner.spin().then(function() {

        Promise.all(_self._wildPromises).then(function() {
            _self._resultController.control(_self._getServerResult());
        });

    });

    // this._requestResult(data);
};

Game.prototype._onReelsStart = function() {
    events.dispatch(REELS_EVENTS.REELS_START);

    MI.controls.unsetForceStop();

    MI.setState("ROTATED", 1);
    MI.controls.showStop();

    MI.controls.winAnimReset();
};

Game.prototype._onReelsComplete = function() {
    madnes_reels_stop();
    MI.setState("ROTATED", 0);
    MI.controls.unsetForceStop();

    this._forceScatterSoundPlayed = false;
    this._forceStopSoundPlayed = false;
};

/**  @param {ReelManager} reel */
Game.prototype._onReelStop = function(reel) {
    this.wild.checkWildResult(reel.getReel().id);

    if (reel.getReel().id === 2 && !this.bonus.inBonus())
        states.setState(STATES.FORCESPIN);

    //console.log('stop');
    //console.timeEnd('r' + reel.id);
};

/**  @param {ReelManager} reel */
Game.prototype._onReelBrakeUp = function(reel) {
    if(reel.getReel().id === 3 && this._getServerResult().getSearchingScatter() < 2 && !this._getServerResult().getLineWins()) {
        this._forceAutostartEnabled = true;
        MI.controls.showSpin();
    }

    var prom = this.wild.uncheckWildResult(reel.getReel().id);

    prom && this._wildPromises.push(prom);
};

/** @param {ReelManager} reel */
Game.prototype._onReelBrakeDown = function(reel) {
    this._playStopSound(reel);
    reel.killSpinSymbols();

    if(reel.getReel().id === 3) {
        this.sounds["reel_spin"].fadeOut(200);
    }

};

Game.prototype._requestResult = function(data) {
    if(this._resultRequestLock) {
        return;
    }

    var _self = this;

    this._resultRequestLock = true;

    this._getResult(data).then(function() {

        for(var i = 0; i < _self.spinReels.getReelsManagers().length; i++) {

            _self.spinReels.getReelManager(i).addSymbolsToStop(_self._getReelDuration(i, _self._getServerResult().getSearchingScatter()));
            _self.spinReels.getReelManager(i).stop();
        }

    });
};

Game.prototype._getResult = function() {

    var _self = this;

    return new Promise(function(res) {

        _self._serverResult.init(MI.server.getResult());
        _self.memory.reinit(_self._serverResult);
        _self.spinReels.prepareResult(_self._serverResult.getReelMatrix(0)/*, searchScatter*/);
        res();
    });
};

/**
 * @returns {ServerResult}
 */
Game.prototype._getServerResult = function() {
    return this._fsServerResult ? this._fsServerResult : this._serverResult;
};

/**
 * @param {number} amount
 * @returns {undefined}
 */
Game.prototype.addWin = function(amount) {
    madnes_add_win(amount);
    this.freeSpinData["roundWin"] += amount;
};

/**
 * @returns {number}
 */
Game.prototype.getWin = function() {
    return MI.getWin();
};

/**
 * @returns {boolean}
 */
Game.prototype.isWin = function() {
    return this.getWin() > 0;
};

/**
 * @param {number} amount
 * @param {number} bet
 * @returns {boolean}
 */
Game.prototype.isBigWin = function(amount, bet) {
    return amount >= MI.getBigWinFactor() * MI.getMoneyBet(bet);
};

/**
 * @param {number} amount
 * @param {number} bet
 * @returns {boolean}
 */
Game.prototype.isMegaWin = function(amount, bet) {
    return amount >= MI.getMegaWinFactor() * MI.getMoneyBet(bet);
};

/**
 * @param {number} amount
 * @param {number} bet
 * @returns {boolean}
 */
Game.prototype.isSuperMegaWin = function(amount, bet) {
    return amount >= MI.getSuperMegaWinFactor() * MI.getMoneyBet(bet);
};

Game.prototype.isBonusWin = function() {
    return false;
};

/**
 * @param {number} win
 * @param {number} bet
 * @returns {number}
 */
Game.prototype.getWinType = function(win, bet) {

    /*if(this.inFreeSpins) {

        return this.BONUS_WIN;

    } else*/ if(this.isSuperMegaWin(win, bet)) {

        return this.SUPER_MEGA_WIN;

    } else if(this.isMegaWin(win, bet)) {

        return this.MEGA_WIN;

    } else if(this.isBigWin(win, bet)) {

        return this.BIG_WIN;

    }

    return this.NORMAL_WIN;
};

/**
 * @private
 * @param {number} reelId
 * @param {number} searchingType
 * @returns {number}
 */
Game.prototype._getReelDuration = function(reelId, searchingType) {
    return reelId * (this._serverConfig.getDelayBetweenReelStops());
};

Game.prototype._decreaseAutoStartCount = function() {
    if(MI.getAutoStart() !== "∞" && MI.getAutoStart() > 0 && !this.inFreeSpins) {
        MI.autoStartDec();
    }
};

/**
 * @returns {boolean}
 */
Game.prototype.roundRunning = function() {
    return MI.server.roundRunning();
};

/**
 *
 * @param {ReelManager} reel
 * @returns {undefined}
 */
Game.prototype._playStopSound = function(reel) {

    if(reel.isReelHided()) {
        return;
    }

    if(reel.getReel().forceStopping) {
        if(reel.hasBonus()) {
            if(!this._forceScatterSoundPlayed) {
                this.sounds["reel_stop"].play();
                this.sounds["symbol_star"].play();
                this._forceScatterSoundPlayed = true;
            }
            return;
        }

        if(!this._forceStopSoundPlayed) {
            this.sounds["reel_stop"].play();
            this._forceStopSoundPlayed = true;
        }
        return;
    }

    if(reel.hasBonus()) {
        this.sounds["reel_stop"].play();
        this.sounds["symbol_star"].play();
        return;
    }

    this.sounds["reel_stop"].play();

};

/**
 * @param {boolean} enabled
 */
Game.prototype.setForceAutostartEnabled = function(enabled) {
    this._forceAutostartEnabled = enabled;
};

Game.prototype.spinPressed = function() {

    if(/*MI.getState("ROTATED") &&*/ this._forceAutostartEnabled) {
        this._resultController.setForceAutostart(true);
    }

    this._forceAutostartEnabled = false;
};

Game.prototype._endRoundRecalced = function () {

    this.spinEnabled = true;

    this.bonus.checkEnd();
    this.lastRoundEnded = true;
    this.spinEnabled = true;

};